import React from "react";
const CustomerTable = ({filters}) => {

    return (
        <thead className='header-customer'>
            <tr>
                <th className="centered-columns padding">Customer</th>
                {filters?.password && <th className="centered-columns">Password</th>}
                {filters?.creditLimit && <th className="centered-column">Credit Limit</th>}
                {/* {filters?.settleLimit && <td>Settle Limit</td>} */}
                {filters?.wagerLimit && <th className="column-info">Wager Limit</th>}
                {filters?.balanceForwardCarry && <th className="column-info">Balance</th>}
                {filters?.pendingBalance && <th className="centered-column">Pending</th>}
                {/* <th>P. Max Bet</th>
                <th>T. Max Bet</th> */}
                <th className="column-info">Status</th>
                {filters?.email && <th className="centered-column">Email</th>}
                {filters?.lastLogin && <th className="centered-column">Last Login</th>}
                <th className="centered-column actions-column">Actions</th>
            </tr>
        </thead>
    );
};

export default CustomerTable;